/**
 * StreamingIndicator - Thinking indicator while waiting for AI response
 *
 * Matches Figma ReasoningTrigger: logo + shimmer "Thinking" text.
 */

import { useTranslation } from '@/i18n'

export function StreamingIndicator() {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-2">
      <img
        src="/images/intuai-logo-icon.svg"
        alt=""
        className="w-4 h-4 flex-shrink-0"
        aria-hidden="true"
      />
      <span className="text-sm font-medium thinking-shimmer">
        {t('chatv2:messages.thinking_short', { defaultValue: 'Thinking' })}
      </span>
    </div>
  )
}

export default StreamingIndicator
